export default __webpack_public_path__ + "static/media/ui-project-1.41def4d8.jpg";